document.addEventListener('DOMContentLoaded', function () {

    const checkbox = document.getElementById('email-opt-in');
    const submitBtn = document.getElementById('submit-btn');

    setInterval(() => {
        submitBtn.disabled = !checkbox.checked;
    }, 200);

    // Wait until Shopify's CountryProvinceSelector is defined
    if (typeof Shopify !== 'undefined' && typeof Shopify.CountryProvinceSelector !== 'undefined') {
        new Shopify.CountryProvinceSelector(
            'trade_business_country',           // Match the ID of country select
            'trade_business_province',          // Match the ID of province select
            {
                hideElement: 'business_province_container' // Match the ID of province container
            }
        );
    }


    // === Support for multiple file upload containers ===
    const attachmentSections = document.querySelectorAll('.attachment-section');

    attachmentSections.forEach((section) => {
        const fileInput = section.querySelector('input[type="file"]');
        const fileButton = section.querySelector('.file-select-btn');
        const uploadedContainer = section.querySelector('.uploaded-file-container');
        const isBusinessSection = section.id === 'business-documents-upload';

        const fileLimit = isBusinessSection ? 2 : 1;

        fileButton.addEventListener('click', () => {
            if (uploadedContainer.children.length < fileLimit) {
                fileInput.click();
            }
        });

        fileInput.addEventListener('change', () => {
            const file = fileInput.files[0];
            if (!file) return;

            if (uploadedContainer.children.length >= fileLimit) {
                fileInput.value = '';
                return;
            }

            const fileItem = document.createElement('div');
            fileItem.className = 'uploaded-file-item';

            const fileName = document.createElement('div');
            fileName.className = 'uploaded-file-name';
            fileName.textContent = file.name;

            const removeBtn = document.createElement('button');
            removeBtn.type = 'button';
            removeBtn.className = 'remove-file-btn';
            removeBtn.textContent = window?.theme?.strings?.remove || 'Remove';

            removeBtn.addEventListener('click', () => {
                fileItem.remove();
                fileInput.value = '';
                fileButton.disabled = false;
            });

            fileItem.appendChild(fileName);
            fileItem.appendChild(removeBtn);
            uploadedContainer.appendChild(fileItem);

            if (uploadedContainer.children.length >= fileLimit) {
                fileButton.disabled = true;
            }
        });
    });

    document.querySelector('#trade-form').addEventListener('submit', function (e) {
        const businessContainer = document.querySelector('#business-documents-upload .uploaded-file-container');
        const taxContainer = document.querySelector('#tax-documents-upload .uploaded-file-container');

        const businessError = document.querySelector('#business-documents-upload .attachment-error[data-doc-type="business"]');
        const taxError = document.querySelector('#tax-documents-upload .attachment-error[data-doc-type="tax"]');

        let isValid = true;

        // === URL Validation ===
        const urlInputs = this.querySelectorAll('input[autocomplete="url"]');

        const isProbablyValidDomain = (url) => {
            const pattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
            return pattern.test(url);
        };

        urlInputs.forEach((input) => {
            const errorEl = input.closest('.field').querySelector('.url-error');
            const raw = input.value.trim();

            if (errorEl) errorEl.style.display = 'none';

            if (raw === '') return;

            // Add https:// if missing
            const formatted = /^(https?:)?\/\//i.test(raw) ? raw : `https://${raw}`;
            input.value = formatted;

            // Validate full structure
            if (!isProbablyValidDomain(formatted)) {
                if (errorEl) errorEl.style.display = 'block';
                isValid = false;
            }
        });

        // === File Upload Validation ===
        if (businessContainer.children.length === 0) {
            businessError.style.display = 'flex';
            isValid = false;
        } else {
            businessError.style.display = 'none';
        }

        if (taxContainer.children.length === 0) {
            taxError.style.display = 'flex';
            isValid = false;
        } else {
            taxError.style.display = 'none';
        }

        if (!isValid) {
            e.preventDefault();
        }
    });

});